import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import PartyTabSection from '@/components/common/PartyTabSection';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import { PARTY_TAB_SECTIONS_MAX_ITEMS } from '@/features/party/constants';
import useLocalSettings from '@/stores/useLocalSettings';

import useDocuments from '../../queries/hooks/useDocuments';

import DocumentItem from './DocumentItem';

export default function DocumentsSection() {
  const { t } = useTranslation();

  const { onlyShowRelevant } = useLocalSettings();

  const party = useSelectedParty();
  const {
    analysis: {
      relevant: { documentIds },
    },
  } = useEmail();

  const { data: documents, isLoading } = useDocuments(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  const shownItems = onlyShowRelevant
    ? documents?.filter((document) => documentIds?.includes(document.id))
    : documents?.slice(0, PARTY_TAB_SECTIONS_MAX_ITEMS);

  return (
    <PartyTabSection
      icon={FileText}
      title={t('DOCUMENTS')}
      noItemsMessage={t('DOCS_NONE')}
      more="/documents"
      isLoading={isLoading}
      totalItems={documents?.length ?? 0}
      relevantItems={documentIds?.length ?? 0}
    >
      {shownItems?.map((document) => (
        <DocumentItem key={document.id} document={document} />
      ))}
    </PartyTabSection>
  );
}
